import React, {Component} from 'react';

import { CSSTransition } from 'react-transition-group';

import ThanksDisplay from './ThanksDisplay.js';
import InfomationDisplayComponent from '../components/displayStateComponent/InfomationDisplayComponent.js';

export default class ThanksView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            workMode:'thanksDisplay',

            isInfoDisplayShown:false,
            infoDisplayImage:'',
            infoDisplayColor:'#55555',
            infoDisplayMessage:'',
        }
    }

    showInfoDisplay = (image,color,message,time) => {        
        this.setState({
            isInfoDisplayShown:true,
            infoDisplayImage:image,
            infoDisplayColor:color,
            infoDisplayMessage:message,
        });
        setTimeout(() => {
            this.setState({isInfoDisplayShown:false});
        }, (typeof time !== 'undefined' ? time : 700 ) )
    }

    render() {

        const viewFrameStyle = {height:'100%',position:'relative'};

        return (
            <div style={viewFrameStyle}>
              <ThanksDisplay
              onInfoDisplayCall={this.showInfoDisplay}
              />

              <CSSTransition
              in={this.state.isInfoDisplayShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <InfomationDisplayComponent 
                image={this.state.infoDisplayImage} 
                fillColor={this.state.infoDisplayColor}
                message={this.state.infoDisplayMessage}
                />
              </CSSTransition>

            </div>
        )
    }
}